import { Formik } from 'formik';
import React, { useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import * as Yup from "yup";
import FormField from "../layout/FormField";

const EditRedeemRewardPoint = () => {

    const validate = Yup.object({
        route_name: Yup.string().required("Required"),
        commuter_name: Yup.string().required("Required"),
        reward_title: Yup.string().required("Required"),
        points_spent: Yup.number().required("Required"),
        time_stamp: Yup.date().required("Required"),

    });
    const vendorOptions = [{ value: 1, label: "Vendor 1" },
    { value: 2, label: "Vendor 2" },
    { value: 3, label: "Vendor 3" },
    { value: 4, label: "Vendor 4" }]
    const stationOptions = [{ value: 1, label: "station 1" },
    { value: 2, label: "station 2" },
    { value: 3, label: "station 3" },
    { value: 4, label: "station 4" }]
    const timingArray = [{ value: 1, label: "station 1" },
    { value: 2, label: "station 2" },
    { value: 3, label: "station 3" },
    { value: 4, label: "station 4" }]

    const customStyles = {
        input: (provided, state) => ({
            ...provided,
            // color: '#29cfb1',
            padding: '5px 0px',
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: '#ced4da',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            marginLeft: 5,
        }),
        menuList: (provided, state) => ({
            ...provided,
            fontSize: 14,
            color: "#a4a4a4",
        }),
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';
            return { ...provided, opacity, transition, };
        }
    }

    const [multiRetailers, setMultiRetailers] = useState([])
    const [multiStations, setMultiStations] = useState([])
    const [multiTimings, setMultiTimings] = useState([])


    return (
        <>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={8} lg={11} className="shadow-lg p-5 m-3">
                    <Formik
                        initialValues={{
                            route_name: "",
                            commuter_name: "",
                            reward_title: "",
                            points_spent: "",
                            time_stamp: ""
                        }}
                        validationSchema={validate}
                        onSubmit={(values) => {
                        }}
                    >
                        {(formik) => (
                            <Form>
                                <Row>
                                    <Col xs={12} sm={12} md={11} lg={6} className="mb-2">
                                        <FormField className="form-control common-input" label="Route Name" name="route_name" type="text" placeholder="Enter name" />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <label htmlFor="commuter_name">Commuter Name</label>
                                        <select value={""} onChange={e => { }} className="common-selector" name="commuter_name">
                                            {/* <option hidden>Transit Type</option> */}
                                            <option value="bus">Bus</option>
                                            <option value="subway">Subway</option>
                                            <option value="train">Train</option>
                                            <option value="streetCar">Street Car</option>
                                        </select>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <FormField className="form-control common-input" label="Length of Route"
                                            name="reward_title" type="number" placeholder="Route length" />
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <FormField className="form-control common-input" label="Points Spent"
                                            name="points_spent" type="number" placeholder="Points spent" />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <FormField className="form-control common-input" label="Time Stamp"
                                            name="time_stamp" type="datetime-local" placeholder="Time stamp here" />

                                    </Col>

                                </Row>

                                <div className="text-end">
                                    <Link to="/routes">
                                        <Button className="theme-cancel-btn me-3">
                                            Cancel
                                        </Button>
                                    </Link>
                                    <Button type="submit" className="theme-btn">
                                        Add
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Col>
            </Row>
        </>
    );

}

export default EditRedeemRewardPoint